export default "__VITE_ASSET__C2r7BfOz__"